import { Chip, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, FormHelperText, Grid, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Select, TextField, Typography } from "@material-ui/core";
import React, { Component } from "react";
import AppBarModal from "../../general/AppBarModal";
import { BtnForm, BtnFormPage } from "../../general/BotonesAccion";
import { consulta, formulario, generarFiltros, getError, obtenerValoresFiltros, validateInputs } from "../../../global/js/funciones";
import { ACREDITACIONES, CODIGO_OTRO_SUBTIPO_RED, CODIGO_SUBTIPO_CONVENIO_OTRO, PAISES, PROGRAMAS, SUBTIPOS_CONVENIOS, SUBTIPOS_RED_ASOCIACION, TIPOS_INSTITUCIONES_IES, TIPOS_RED_ACADEMICA } from "../administrar/helper";
import { ValidatorForm } from "react-material-ui-form-validator";
import { use } from "react";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';
import moment from 'moment';
import InputBuscar from "../../general/InputBuscar";
import AgregarValor from "../ui/AgregarValor";
import CargandoInter from "../ui/CargandoInter";
import { actualizarMensaje } from "../../../redux/actions/actGlobal";
import { Alert } from "@material-ui/lab";

class RedCrear extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cargando: false,
      guardando: false,
      errores: [],
      paises: [],
      subtipos: [],
      programas: [],
      tipos_instituciones: [],
      tipo_institucion: "",
      tipos_red_academica: [],
      tipo_red_academica: "",
      subtipos_red: [],
      subtipo_red: "",
      otro_subtipo_red: "",
      nombre_red: "",
      paginawebies: "",
      proposito_red: "",
      pais_red: [],
      paises_sele: [],
      subtipo_convenio: [],
      otro_subtipo_convenio: "",
      objeto_red: "",
      telefono_enlace_vin: "",
      programas_red: [],
      programas_sele: [],
      modal_agg_pais: false,
      modal_agg_programa: false,
      dataConvenio: [],
      nombre_enlace_vin: "",
      email_enlace_vin: "",
      todas_instituciones: [],
      instituciones_filtradas: [],
      instituciones_sele: [],
      instituciones_ids: [],
      termino_busqueda: "",
      fecha_vencimiento: null
    }
  }

  async componentDidMount() {
    this.setState({ cargando: true });
    await this.obtenerGenericas()
    this.setState({ cargando: false });
  }

  async componentDidUpdate({ modalAddRed, modalEdiIes }, { }) {
    let { modalAddRed: modalAddRedNew, modalEdiIes: modalEdiIesNew, id_institucionActual } = this.props;
    if (modalAddRed !== modalAddRedNew) {
      if (!modalAddRedNew) {
        this.setState({ nombre_red: "", pais_red: [], subtipo_convenio: [], otro_subtipo_convenio: "", programas_red: [], objeto_red: "", tipo_institucion: "", paginawebies: "", proposito_red: "", subtipo_red: "", otro_subtipo_red: "" });
      }
    }
    if (modalEdiIes !== modalEdiIesNew) {
      if (modalEdiIesNew) {
        this.setState({ cargando: true });
        let inf_conevnio = [], convenio = [];
        convenio = await this.obtenerInfoSolicitud(id_institucionActual);
        inf_conevnio = await this.obtenerBorradorInfConvenio(id_institucionActual);
        this.cargarDatosBorrador(convenio, inf_conevnio)
        this.setState({ cargando: false });
      }
    }

  }

  esInstitucion = () => {
    let { opcionDetalle, subtipo_solicitud } = this.props;
    return (opcionDetalle && opcionDetalle.codigo === "otras_inst_sol") || subtipo_solicitud === "otras_inst_sol";
  }

  esOtroSubtipoRed = () => {
    let { subtipos_red, subtipo_red } = this.state;
    let seleccionado = subtipos_red.find(({ id }) => id === subtipo_red);
    return !!seleccionado && seleccionado.codigo === CODIGO_OTRO_SUBTIPO_RED;
  }

  obtenerGenericas = async () => {
    let paises = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': PAISES }]);
    let subtipos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': SUBTIPOS_CONVENIOS }]);
    let programas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': PROGRAMAS }]);
    let tipos_instituciones = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_INSTITUCIONES_IES }]);
    let tipos_red_academica = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_RED_ACADEMICA }]);
    let subtipos_red = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': SUBTIPOS_RED_ASOCIACION }]);
    this.setState({ subtipos, paises, programas, tipos_instituciones, tipos_red_academica, subtipos_red });
  }

  async obtenerBorradorInfConvenio(id_convenio) {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/internacionalizacion/solicitudes/${id_convenio}/obtener_pasoInfConvenio`,
        null,
        null,
        (error, estado, resp) => {
          resolve(estado === 200 && !error ? resp : null);
        }
      );
    });
  }

  async obtenerInfoSolicitud(id) {
    return new Promise(async (resolve) => {
      let f = await generarFiltros([{ 'llave': 'id', 'valor': id }]);
      consulta(
        `api/v1.0/internacionalizacion/solicitud/convenio?${f}`,
        null,
        null,
        (error, estado, resp) => {
          resolve(estado === 200 && !error ? resp[0] : null);
        }
      );
    });
  }


  async cargarDatosBorrador(datos, inf_conevnio) {
    let { institucion, otro_subtipo_convenio, pais_vinculante, programa_facultad_3, paises_red_academica, objeto_del_convenio, programas_red_academica, telefono_enlace_vin, email_enlace_vin, nombre_enlace_vin } = datos;
    let { TipoConvenio, Subtipo_convenio } = inf_conevnio;
    let helpTipoConvenio = [], helpSubtipo_convenio = [], helpPaises = [], helpProgramas = [];

    this.setState({
      nombre_red: institucion ? institucion : "",
      pais_red: pais_vinculante ? [{ id: pais_vinculante.id, nombre: pais_vinculante.nombre }] : [],
      otro_subtipo_convenio: otro_subtipo_convenio ? otro_subtipo_convenio : "",
      objeto_red: objeto_del_convenio ? objeto_del_convenio : "",
      telefono_enlace_vin: telefono_enlace_vin ? telefono_enlace_vin : "",
      email_enlace_vin: email_enlace_vin ? email_enlace_vin : "",
      nombre_enlace_vin: nombre_enlace_vin ? nombre_enlace_vin : "",
      tipo_institucion: datos.tipo_institucion ? datos.tipo_institucion.id : "",
      paginawebies: datos.paginawebies ? datos.paginawebies : "",
      proposito_red: datos.proposito_red ? datos.proposito_red : "",
      tipo_red_academica: datos.tipo_red_academica ? datos.tipo_red_academica.id : "",
      subtipo_red: datos.subtipo_red_academica ? datos.subtipo_red_academica.id : "",
      otro_subtipo_red: datos.otro_subtipo_red ? datos.otro_subtipo_red : ""
    });
    if (TipoConvenio.length > 0) {
      TipoConvenio.map((item) => {
        helpTipoConvenio.push(item.tipo_convenio_convenio.id);
      });
      this.setState({ tipo_convenio: helpTipoConvenio });
    }
    if (Subtipo_convenio.length > 0) {
      Subtipo_convenio.map((item) => {
        helpSubtipo_convenio.push(item.sub_tipo_convenio.id);
      });
      this.setState({ subtipo_convenio: helpSubtipo_convenio });
    }
    if (paises_red_academica.length > 0) {
      let selec = []
      paises_red_academica.map((item) => {
        helpPaises.push({ id: item.id, nombre: item.nombre });
        selec.push(item.id)
      });
      this.setState({ pais_red: helpPaises, paises_sele: selec });
    }
    if (programas_red_academica.length > 0) {
      let selec = []
      programas_red_academica.map((item) => {
        helpProgramas.push({ id: item.id, nombre: item.nombre });
        selec.push(item.id)
      });
      this.setState({ programas_red: helpProgramas, programas_sele: selec });
    }
  }
  cargarTodasInstituciones = async () => {
      consulta(
        `api/v1.0/internacionalizacion/listar-instituciones/`,
        null,
        null,
        (error, estado, resp) => {
          if (error) {
            console.error('Error cargando instituciones:', error);
            return;
          }

          if (estado === 200 && resp.instituciones) {
            this.setState({ 
              todas_instituciones: resp.instituciones 
            });
          }
        }
      );
    };


    filtrarInstituciones = (termino) => {
      this.setState({ termino_busqueda: termino });
      
      if (termino.length < 2) {
        this.setState({ instituciones_filtradas: [] });
        return;
      }

      const { todas_instituciones, instituciones_sele } = this.state;
      const idsSeleccionados = instituciones_sele.map(inst => inst.id);
      
      const filtradas = todas_instituciones
        .filter(inst => 
          !idsSeleccionados.includes(inst.id) &&
          inst.institucion.toLowerCase().includes(termino.toLowerCase())
        )
        .slice(0, 20); // Limitar a 20 resultados

      this.setState({ instituciones_filtradas: filtradas });
    };

    agregarInstitucion = (institucion) => {
      const { instituciones_sele, instituciones_ids, errores } = this.state;
      
      this.setState({
        instituciones_sele: [...instituciones_sele, institucion],
        instituciones_ids: [...instituciones_ids, institucion.id],
        instituciones_filtradas: [],
        termino_busqueda: "",
        errores: errores.filter(er => er.llave !== "instituciones_sele")
      });
    };

    quitarInstitucion = (id) => {
      const { instituciones_sele, instituciones_ids } = this.state;
      
      this.setState({
        instituciones_sele: instituciones_sele.filter(inst => inst.id !== id),
        instituciones_ids: instituciones_ids.filter(instId => instId !== id)
      });
    };


  handleChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value,
    });
  };

  formularioRed = () => {
    const CHARACTER_LIMIT = 250;
    let { errores, paises, subtipos, modal_agg_pais, modal_agg_programa, programas, nombre_red, pais_red, subtipo_convenio, otro_subtipo_convenio, programas_red, objeto_red, paises_sele, programas_sele, telefono_enlace_vin, nombre_enlace_vin, email_enlace_vin, instituciones,
    instituciones_sele, termino_busqueda, instituciones_filtradas, paginawebies, tipos_instituciones, tipo_institucion, proposito_red, tipos_red_academica, tipo_red_academica, subtipos_red, subtipo_red, otro_subtipo_red } = this.state;

    const esInstitucion = this.esInstitucion;

    return (
      <>
        <ValidatorForm>
          <Grid
            container
            spacing={3}
            style={{ marginTop: "1%", marginBottom: "1%" }}
          >
            <Grid item xs={12}>
              <TextField
                value={nombre_red}
                required
                error={getError("nombre_red", errores).length > 0}
                helperText={getError("nombre_red", errores)}
                type="text"
                id="nombre_red"
                name="nombre_red"
                label={esInstitucion() ? "Nombre de la institución" : "Nombre de la red o asociación académica"}
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            {esInstitucion() && (
              <Grid item xs={6} style={{ marginTop: "1%"}}>
                <FormControl fullWidth error={getError('pais_red', errores).length > 0}>
                  <InputBuscar
                    label="País"
                    placeholder={"Seleccione el país"}
                    id="pais_red"
                    value={
                      pais_red.length > 0
                        ? pais_red
                          .map((r) => r.nombre)
                          .join(", ")
                        : ""
                    }
                    // callback={() => this.setState({ modal_agg_pais: true })}
                    callback={() => {
                      this.setState({ modal_agg_pais: true }, () => {
                        if (errores && errores.length > 0) {
                          this.setState({ errores: errores.filter(er => er.llave !== "pais_red") });
                        }
                      });
                    }}
                    icon_default={false}
                  />
                </FormControl>
                <FormHelperText style={{ color: "#FF2D00" }}>{getError('pais_red', errores)}</FormHelperText>
                <AgregarValor
                  modalOpen={modal_agg_pais}
                  mostrarModal={(modal) => this.setState({ modal_agg_pais: modal })}
                  nombreModal="Paises"
                  datos={paises}
                  opciones={true}
                  buscar={true}
                  fila_principal="nombre"
                  listaSeleccionados={pais_red}
                  seleccionarVarios={true}
                  seleccionar={({ id, nombre }) => {
                    this.setState({
                      pais_red: [...pais_red, { id, nombre }],
                      paises_sele: [...paises_sele, id]
                    });
                  }}
                  quitar={({ id }) => {
                    this.setState({
                      pais_red: pais_red.filter((pais) => pais.id !== id),
                      paises_sele: paises_sele.filter((p) => p !== id)
                    });
                  }}
                />
              </Grid>
            )}
            {esInstitucion() && (
              <Grid item xs={6} style={{ marginTop: "1%"}}>
                <FormControl
                  className="form-control"
                  required
                  fullWidth
                  error={getError("tipo_institucion", errores).length > 0}
                >
                  <InputLabel id="tipo_institucion_label">
                    Tipo institución
                  </InputLabel>
                  <Select
                    labelId="tipo_institucion_label"
                    id="tipo_institucion"
                    name="tipo_institucion"
                    value={tipo_institucion}
                    fullWidth
                    onChange={this.handleChange}
                  >
                    {tipos_instituciones.map(({ id, nombre }) => (
                      <MenuItem key={id} value={id}>
                        {nombre}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {getError("tipo_institucion", errores)}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}
            {!esInstitucion() && (
              <Grid item xs={6} style={{ marginTop: "1%"}}>
                <FormControl
                  className="form-control"
                  required
                  fullWidth
                  error={getError("tipo_red_academica", errores).length > 0}
                >
                  <InputLabel id="tipo_red_academica_label">
                    Tipo
                  </InputLabel>
                  <Select
                    labelId="tipo_red_academica_label"
                    id="tipo_red_academica"
                    name="tipo_red_academica"
                    value={tipo_red_academica}
                    fullWidth
                    onChange={this.handleChange}
                  >
                    {tipos_red_academica.map(({ id, nombre }) => (
                      <MenuItem key={id} value={id}>
                        {nombre}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {getError("tipo_red_academica", errores)}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}
            {!esInstitucion() && (
              <Grid item xs={6} style={{ marginTop: "1%"}}>
                <FormControl
                  className="form-control"
                  required
                  fullWidth
                  error={getError("subtipo_red", errores).length > 0}
                >
                  <InputLabel id="subtipo_red_label">
                    Subtipo
                  </InputLabel>
                  <Select
                    labelId="subtipo_red_label"
                    id="subtipo_red"
                    name="subtipo_red"
                    value={subtipo_red}
                    fullWidth
                    onChange={this.handleChange}
                  >
                    {subtipos_red.map(({ id, nombre }) => (
                      <MenuItem key={id} value={id}>
                        {nombre}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {getError("subtipo_red", errores)}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}
            {!esInstitucion() && this.esOtroSubtipoRed() && (
              <Grid item xs={12}>
                <TextField
                  value={otro_subtipo_red}
                  required
                  error={getError("otro_subtipo_red", errores).length > 0}
                  helperText={getError("otro_subtipo_red", errores)}
                  type="text"
                  id="otro_subtipo_red"
                  name="otro_subtipo_red"
                  label="Especifique el subtipo"
                  fullWidth
                  onChange={this.handleChange}
                  inputProps={{ maxLength: 254 }}
                />
              </Grid>
            )}
            {/* <Grid item xs={6}>
              <FormControl
                className="form-control"
                required
                error={getError("subtipo_convenio", errores).length > 0}
              >
                <InputLabel id="subtipo_convenio_label">
                  Funciones misionales que impacta
                </InputLabel>
                <Select
                  labelId="subtipo_convenio_label"
                  id="subtipo_convenio"
                  name="subtipo_convenio"
                  value={subtipo_convenio}
                  fullWidth
                  multiple
                  onChange={this.handleChange}
                >
                  {subtipos
                    .sort(
                      ({ id: previousID }, { id: currentID }) =>
                        previousID - currentID
                    )
                    .map((tipo) => (
                      <MenuItem key={tipo.id} value={tipo.id}>
                        {tipo.nombre}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText>
                  {getError("subtipo_convenio", errores)}
                </FormHelperText>
              </FormControl>
            </Grid> */}
            {/* {subtipo_convenio.includes(CODIGO_SUBTIPO_CONVENIO_OTRO) && (
              <Grid item xs={12}>
                <TextField
                  value={otro_subtipo_convenio}
                  id="otro_subtipo_convenio"
                  required
                  error={getError("otro_subtipo_convenio", errores).length > 0}
                  helperText={getError("otro_subtipo_convenio", errores)}
                  name="otro_subtipo_convenio"
                  label="Otro subtipo de convenio"
                  fullWidth
                  onChange={this.handleChange}
                />
              </Grid>
            )} */}
            <Grid item xs={6} style={{ marginTop: "1%"}}>
              <TextField
                value={paginawebies}
                required
                error={getError("paginawebies", errores).length > 0}
                helperText={getError("paginawebies", errores)}
                type="text"
                id="paginawebies"
                name="paginawebies"
                label="Dirección página web de la IES"
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            {!esInstitucion() && (
              <Grid item xs={12}>
                <TextField
                  value={proposito_red}
                  multiline
                  required
                  error={getError('proposito_red', errores).length > 0}
                  helperText={`${proposito_red.length}/${CHARACTER_LIMIT}`}
                  rows={4}
                  id='proposito_red'
                  name='proposito_red'
                  label="Propósito de la red"
                  fullWidth
                  onChange={this.handleChange}
                  inputProps={{ maxLength: CHARACTER_LIMIT }}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Alert severity="info">
                (i) A continuación debes incluir la información del contacto de la {esInstitucion() ? "institución" : "Red o Asociación"}
              </Alert>
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={nombre_enlace_vin}
                required
                error={getError("nombre_enlace_vin", errores).length > 0}
                helperText={getError("nombre_enlace_vin", errores)}
                type="text"
                id="nombre_enlace_vin"
                name="nombre_enlace_vin"     
                label="Nombre del contacto"
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={email_enlace_vin}
                required
                error={getError("email_enlace_vin", errores).length > 0}
                helperText={getError("email_enlace_vin", errores)}
                type="text"
                id="email_enlace_vin"
                name="email_enlace_vin"
                label="Email del contacto"
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  id='fecha_vencimiento'
                  required
                  error={getError('fecha_vencimiento', errores).length > 0}
                  helperText={getError('fecha_vencimiento', errores)}
                  label='Fecha de vencimiento del convenio'
                  name='fecha_vencimiento'
                  format='dd/MM/yyyy'
                  value={fecha_vencimiento}
                  onChange={(date) => this.setState({ fecha_vencimiento: date })}
                  fullWidth
                  KeyboardButtonProps={{ "aria-label": "change date" }}
                />
              </MuiPickersUtilsProvider>
            </Grid> */}
            <Grid item xs={4}>
              <TextField
                value={telefono_enlace_vin}
                error={getError("telefono_enlace_vin", errores).length > 0}
                helperText={getError("telefono_enlace_vin", errores)}
                type="number"
                id="telefono_enlace_vin"
                name="telefono_enlace_vin"
                label="Teléfono del contacto"
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
          </Grid>
        </ValidatorForm>
      </>
    );
  };

  resetState = () => {
    this.setState({ 
      nombre_red: "", 
      pais_red: [], 
      subtipo_convenio: [], 
      otro_subtipo_convenio: "", 
      programas_red: [], 
      objeto_red: "", 
      cargando: false, 
      telefono_enlace_vin: "", 
      email_enlace_vin: "", 
      nombre_enlace_vin: "", 
      instituciones_sele: [],
      instituciones_ids: [],
      instituciones_filtradas: [],
      termino_busqueda: "",
      tipo_institucion: "",
      paginawebies: "",
      proposito_red: "",
      subtipo_red: "",
      otro_subtipo_red: "" });
  }

  onSubmit = async () => {
    let { errores, nombre_red, pais_red, subtipo_convenio, otro_subtipo_convenio, programas_red, objeto_red, paises_sele, programas_sele, telefono_enlace_vin, email_enlace_vin, nombre_enlace_vin, instituciones_ids, tipo_institucion, paginawebies, proposito_red, tipo_red_academica, subtipo_red, otro_subtipo_red } = this.state;
    let { guardarRedAcademica } = this.props;

    let campos = [
      { value: nombre_red, name: "nombre_red", err: { empty: true } },
      { value: paginawebies, name: "paginawebies", err: { empty: true } },
      { value: email_enlace_vin, name: "email_enlace_vin", err: { empty: true } },
      { value: nombre_enlace_vin, name: "nombre_enlace_vin", err: { empty: true } },
    ];

    if (this.esInstitucion()) {
      campos.push({ value: pais_red, name: "pais_red", err: { empty: true } });
      campos.push({ value: tipo_institucion, name: "tipo_institucion", err: { empty: true } });
    } else {
      campos.push({ value: proposito_red, name: "proposito_red", err: { empty: true } });
      campos.push({ value: tipo_red_academica, name: "tipo_red_academica", err: { empty: true } });
      campos.push({ value: subtipo_red, name: "subtipo_red", err: { empty: true } });
      if (this.esOtroSubtipoRed()) campos.push({ value: otro_subtipo_red, name: "otro_subtipo_red", err: { empty: true } });
    }

    errores = await validateInputs(campos);

    if (subtipo_convenio.includes(CODIGO_SUBTIPO_CONVENIO_OTRO)) {
      if (!otro_subtipo_convenio) {
        errores.push({
          llave: "otro_subtipo_convenio",
          mensaje: `Este campo es obligatorio`,
        });
      }
    }

    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
    }

    if (errores.length === 0) {
      this.setState({ guardando: true });
      let data = { nombre_red, pais_red: paises_sele, subtipo_convenio, otro_subtipo_convenio, programas_red: programas_sele, objeto_red, telefono_enlace_vin, email_enlace_vin, nombre_enlace_vin, instituciones_ids: instituciones_ids.join(','), tipo_institucion, paginawebies, proposito_red, tipo_red_academica, subtipo_red_academica: subtipo_red, otro_subtipo_red: this.esOtroSubtipoRed() ? otro_subtipo_red : "" };
      // El callback se invoca tanto en exito como en error, asi que el flag siempre se apaga
      await guardarRedAcademica(data, () => this.setState({ guardando: false }, () => this.resetState()));
    }
  }

  onSubmitEditar = async () => {

    let { nombre_red, paises_sele, programas_sele, objeto_red, errores, subtipo_convenio, otro_subtipo_convenio, telefono_enlace_vin, pais_red, programas_red, email_enlace_vin, nombre_enlace_vin, tipo_institucion, paginawebies, proposito_red, tipo_red_academica, subtipo_red, otro_subtipo_red } = this.state
    let { id_institucionActual, multiple, editarRedAcademica } = this.props

    let campos = [
      { value: nombre_red, name: "nombre_red", err: { empty: true } },
      { value: paginawebies, name: "paginawebies", err: { empty: true } },
      { value: email_enlace_vin, name: "email_enlace_vin", err: { empty: true } },
      { value: nombre_enlace_vin, name: "nombre_enlace_vin", err: { empty: true } },
    ];

    if (this.esInstitucion()) {
      campos.push({ value: pais_red, name: "pais_red", err: { empty: true } });
      campos.push({ value: tipo_institucion, name: "tipo_institucion", err: { empty: true } });
    } else {
      campos.push({ value: proposito_red, name: "proposito_red", err: { empty: true } });
      campos.push({ value: tipo_red_academica, name: "tipo_red_academica", err: { empty: true } });
      campos.push({ value: subtipo_red, name: "subtipo_red", err: { empty: true } });
      if (this.esOtroSubtipoRed()) campos.push({ value: otro_subtipo_red, name: "otro_subtipo_red", err: { empty: true } });
    }

    errores = await validateInputs(campos);

    if (subtipo_convenio.includes(CODIGO_SUBTIPO_CONVENIO_OTRO)) {
      if (!otro_subtipo_convenio) {
        errores.push({
          llave: "otro_subtipo_convenio",
          mensaje: `Este campo es obligatorio`,
        });
      }
    }

    if (errores.length > 0) {
      this.setState({ errores });
      actualizarMensaje({ titulo: 'Debes llenar los campos obligatorios.', tipo: 'info', mostrar: true, tiempo: 6000 });
    }

    if (errores.length === 0) {
      this.setState({ guardando: true });
      let data = { nombre_red, pais_red: paises_sele, subtipo_convenio, otro_subtipo_convenio, programas_red: programas_sele, objeto_red, id: id_institucionActual, telefono_enlace_vin, email_enlace_vin, nombre_enlace_vin, tipo_institucion, paginawebies, proposito_red, tipo_red_academica, subtipo_red_academica: subtipo_red, otro_subtipo_red: this.esOtroSubtipoRed() ? otro_subtipo_red : "" };
      // El callback se invoca tanto en exito como en error, asi que el flag siempre se apaga
      await editarRedAcademica(data, () => this.setState({ guardando: false }, () => this.resetState()))
    }
  }

  render() {
    let { modalAddRed, handleCloseModal, titulo, editar, modalEdiIes } = this.props;
    let { cargando, guardando } = this.state;
    // Mientras carga o guarda no se puede cerrar el modal por ninguna via
    const bloqueado = cargando || guardando;
    const cerrar = () => { if (!bloqueado) handleCloseModal(); };
    return (
      <Dialog
        open={editar ? modalEdiIes : modalAddRed}
        onClose={cerrar}
        disableBackdropClick={bloqueado}
        disableEscapeKeyDown={bloqueado}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBarModal
          titulo={titulo}
          mostrarModal={cerrar}
          titulo_accion=""
          accion={() => { }}
          close_switch={!bloqueado}
        />
        <DialogContent className="scroll">
          {bloqueado ? <CargandoInter mensaje={guardando ? 'Guardando...' : 'Cargando...'} />
            : this.formularioRed()}
        </DialogContent>
        <DialogActions>
          {bloqueado ? null : <BtnForm texto="CERRAR" callback={cerrar} />}
          {bloqueado ? null : <BtnFormPage texto="GUARDAR" callback={editar ? this.onSubmitEditar : this.onSubmit} type="submit" />}
        </DialogActions>
      </Dialog>
    )
  }
}

export default RedCrear;
